import { render, staticRenderFns } from "./LeaveConfirm.pug?vue&type=template&id=60708a72&lang=pug&"
import script from "./LeaveConfirm.vue?vue&type=script&lang=js&"
export * from "./LeaveConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports